import * as React from "react";
import { Box, useTheme } from "@material-ui/core";
import { themeVariables } from "./_Theme";
import { SvgIcon } from "../../../components";

type offset = number | string;

interface IProps {
  icon: string;
  big?: boolean;
}

export const MUICourseIcon = (props: IProps) => {
  return props.icon ? (
    <img
      src={props.icon}
      alt=""
      width={props.big ? "56" : "40"}
      height={props.big ? "56" : "40"}
      style={{
        display: "block",
      }}
    />
  ) : (
    <Box
      width={props.big ? 56 : 40}
      height={props.big ? 56 : 40}
      bgcolor="grey.A200"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <SvgIcon type="course" />
    </Box>
  );
};
